/**
 * Box type filtering rules for shipment containers.
 *
 * Pallet containers accept only a fixed subset of box types (PALLET_BOX_TYPE_KEYS).
 * All other container kinds (cartons, case packs, ...) accept everything *except*
 * that subset.
 */
export var PALLET_BOX_TYPE_KEYS = ['BtPalletUs4840'];
export var boxKindForContainerType = function (containerTypeEnumId) {
    return containerTypeEnumId === 'CtPallet' ? 'pallet' : 'carton';
};
export var filterBoxTypesForContainer = function (boxTypes, kind) {
    var palletSet = new Set(PALLET_BOX_TYPE_KEYS);
    return kind === 'pallet'
        ? boxTypes.filter(function (b) { return palletSet.has(b.key); })
        : boxTypes.filter(function (b) { return !palletSet.has(b.key); });
};
